// 応募しない求人一覧
import axios from '@/plugins/axios';
import { endpoint } from '@/api/apiConstants';
import { MstMypageVideoKnowHowRequest } from '@/types/request';

export const fetchKnowHowVideo = async (params: MstMypageVideoKnowHowRequest) => {
  const res = await axios.post(endpoint.getMstMypageVideoKnowHow, params);
  return res.data.detail;
};
